import React from 'react';

export const ConfigContext = React.createContext(undefined);
export const IsIntercomContext = React.createContext(undefined);
export const LinkPrefixContext = React.createContext(undefined);
export const OnAuthTokenContext = React.createContext(undefined);
